import React, { useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useFetch from 'use-http';

const SharedBiotronicsView = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
const { token } = useParams();

  const { get: validateViewCode } = useFetch(
    '/UserAccount/ValidateBiotronicsSharedView',
  );

  const handleChange = (e) => {
    // Allow only numbers
    const value = e.target.value.replace(/\D/g, '');

    // Limit to 4 characters
    if (value.length <= 4) {
      setCode(value);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (code.length !== 4) {
      setError('Saugos kodas turi būti 4 skaitmenų');
      return;
    }

    // Submit logic here

    await validateViewCode(`?view=${token}&validationCode=${code}`).then((res)=> {
      if(res.valid)
      {
        const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://cloudpacs-lt.affidea.com/CMStudyLoader.aspx';
    form.target = '_blank';

    const appField = document.createElement('input');
    appField.type = 'hidden';
    appField.name = 'AppId';
    appField.value = res.appId;

    const jwtField = document.createElement('input');
    jwtField.type = 'hidden';
    jwtField.name = 'JWT';
    jwtField.value = res.tokenEnc;

    form.appendChild(appField);
    form.appendChild(jwtField);

    document.body.appendChild(form);
    form.submit();
      }
      else {
        setError("Saugos kodas nesutampa arba nuoroda nebegalioja!")
      }
    })
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center gap-4"
      >
        <label>Norėdami pasiekti informaciją, įveskite saugos kodą</label>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={code}
          onChange={handleChange}
          maxLength={4}
          className="w-32 text-center text-xl border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="1234"
        />

        {error && (
          <div className="text-red-500 text-sm">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={code.length !== 4}
          className="px-6 py-2 rounded bg-blue-600 text-white disabled:bg-gray-400 disabled:cursor-not-allowed cursor-pointer"
        >
          Peržiūrėti
        </button>
      </form>
    </div>
  );
};

export default SharedBiotronicsView;